import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-send\"><defs><style type=\"text/css\"></style></defs><path d=\"M518.183677 0.000139c-45.510159-0.149004-64.540132 106.942489-64.540132 148.237956l-1.277179 228.870549L61.634613 641.825361l0.319295 108.624108 401.949644-186.446906 13.176234 297.455083-164.181412 110.688882 0.298009 51.172321 198.452393-44.509702 196.366333 45.190865-0.149004-51.257467-147.471648-111.306185 9.429841-293.197818 392.498517 183.807402-0.298009-108.602822L584.511861 378.513541l1.596474-229.785861C585.980617 107.240636 563.693836 0.000139 518.183677 0.000139z\" p-id=\"2112\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/send.svg
// module id = 0zCS
// module chunks = 132